import React from 'react';

import '../functions/player';


export class Market extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      funds: this.props.object.funds,
    };

  }

  updateVariables = () => {
    this.setState({
      funds: parseInt(this.props.object.funds, 10)
    });
  }

  render() {
    return(
      <div className="entityWrap">
        <div className="hud" style={this.props.object.imageStyle}>
          <div className="inner" style={this.props.object.hudStyle}>
            <div className="hudContent" style={{paddingBottom: "50%"}}>
              <div className="name" style={{backgroundColor: this.props.object.color}}>
                {this.props.object.name}
              </div>
              <ul className="data">
                <li className="icon icon--funds">{this.state.funds.toFixed(0)}</li>
              </ul>
            </div>
          </div>
        </div>
        <img className="boardElement boardElement--main" src={this.props.object.image} alt='Board Element' style={this.props.object.imageStyle}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/market.js